import React from "react";

type UseAttachmentPreviewNavigationParams = {
  itemIds: string[];
  activeItemId: string | null;
  onActiveItemChange: (id: string) => void;
};

export const useAttachmentPreviewNavigation = ({
  itemIds,
  activeItemId,
  onActiveItemChange,
}: UseAttachmentPreviewNavigationParams) => {
  const activeIndex = React.useMemo(() => {
    if (!activeItemId) return -1;
    return itemIds.findIndex((id) => id === activeItemId);
  }, [activeItemId, itemIds]);

  const canGoPrevious = activeIndex > 0;
  const canGoNext = activeIndex >= 0 && activeIndex < itemIds.length - 1;

  const goPrevious = React.useCallback(() => {
    if (!canGoPrevious) return;
    const previousId = itemIds[activeIndex - 1];
    if (!previousId) return;
    onActiveItemChange(previousId);
  }, [activeIndex, canGoPrevious, itemIds, onActiveItemChange]);

  const goNext = React.useCallback(() => {
    if (!canGoNext) return;
    const nextId = itemIds[activeIndex + 1];
    if (!nextId) return;
    onActiveItemChange(nextId);
  }, [activeIndex, canGoNext, itemIds, onActiveItemChange]);

  return {
    canGoPrevious,
    canGoNext,
    goPrevious,
    goNext,
    activeIndex,
  };
};

export default useAttachmentPreviewNavigation;
